import * as S from './TravellerInfo.styles';
import HappyBedNewIcon from '@stencil/icons/src/HappyBedNewIcon/HappyBedNewIcon';
import HappyMealNewIcon from '@stencil/icons/src/HappyMealNewIcon/HappyMealNewIcon';

export default function HomePageTravellerInfo({
  leftHeader = 'Travelling with children?',
  leftText = 'If you are travelling with children, add number of children and their age to get the best rooms options, prices etc.',
}) {
  return (
    <S.OuterWrapper data-testid="traveller-info">
      <S.FlexWrap>
        <S.ChildPaxInfo_Wrap>
          <S.Left_wrap>
            <S.Left_Header>{leftHeader}</S.Left_Header>
            <p>{leftText}</p>
          </S.Left_wrap>
          <S.Right_wrap>
            <S.List_Available>
              <li>
                <HappyBedNewIcon height="1.5rem" width="1.5rem" margin="0 1rem 0 0" />
                <S.List_text>Extra Mattress</S.List_text>
              </li>
              <li>
                <HappyMealNewIcon height="1.5rem" width="1.5rem" margin="0 1rem 0 0" />
                <S.List_text>Kid Breakfast Inclusive plans</S.List_text>
              </li>
            </S.List_Available>
          </S.Right_wrap>
        </S.ChildPaxInfo_Wrap>
      </S.FlexWrap>
    </S.OuterWrapper>
  );
}
